import { BorderGridContainer, GridBox, Hidden, Image } from '@ahmdigital/ui';
import { PRODUCT } from '@ahmdigital/constants';
import { size } from 'lodash/fp';
import { useRef } from 'react';
import styled from 'styled-components';

import { determineProductIdFromBundles } from '../../utils/bundle';
import BundleChosenView from './components/bundle-chosen-view';
import personaliseYourPriceImage from './images/personalise-your-price.svg';
import styles from './styles.module.sass';
import useAdjustFooterLinks from '../../../../../../elements/footer-links/utils/use-adjusted-footer-links';

const Container = styled.div`
  bottom: -0.5rem;
  margin-top: -0.5rem;
  position: sticky;
  z-index: ${({ theme }) => theme.zIndices.footer};
`;

type JoinBarProps = {
  customer: {
    frequency: string;
  };
  effectiveDate?: string;
  prices?: {};
  selectedBundles: string[];
};

const JoinBar = ({ customer, effectiveDate, prices, selectedBundles }: JoinBarProps) => {
  const joinBarRef = useRef<HTMLDivElement>(null);
  const isBundleChosen = size(selectedBundles) > 0;
  const productId = isBundleChosen ? determineProductIdFromBundles(selectedBundles) : PRODUCT.CHOOSABLE_50_TEETH;

  useAdjustFooterLinks(joinBarRef);

  return (
    <Container ref={joinBarRef}>
      <BorderGridContainer>
        <GridBox padding="1rem">
          <div className={styles.viewWrapper}>
            <Hidden xs sm>
              <Image
                className={styles.personaliseYourPrice}
                src={personaliseYourPriceImage.src}
                alt="Personalise Your Price"
                width="64px"
                height="48px"
              />
            </Hidden>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ customer: { frequency: string; }; effectiveDate: string | undefined; isBundleChosen: boolean; prices: {} | undefined; productId: "choosable-50-teeth" | "choosable-60-teeth-eyes" | ... 7 more ... | undefined; }' is not assignable to type 'Pick<BundleChosenViewProps, "customer" | "productId" | "isBundleChosen">'. */}
            <BundleChosenView
              {...{
                customer,
                effectiveDate,
                isBundleChosen,
                prices,
                productId,
              }}
            />
          </div>
        </GridBox>
      </BorderGridContainer>
    </Container>
  );
};

export default JoinBar;
